// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"Footer_deleteButton__2_ZON","submitButton":"Footer_submitButton__3uUWa"};